import React, { useState } from 'react';

import UserQuestion from 'components/molecules/bidding_chat_user_questions';
import BiddingChatConversation from 'components/molecules/bidding_chat_conversation';
import { Container as BiddingChatStyles } from 'components/organisms/bidding_chat/styles';

import { useBiddingChatSession } from 'hooks/useBiddingChatSession';
import type { BiddingChatMessageTypes } from 'store/modules/bidding_chat/types';

import { Container } from './styles';

const WELCOME_MESSAGE: BiddingChatMessageTypes = {
  id: null,
  bidding_user_chat_id: null,
  role: 'assistant',
  content: 'Faça perguntas estratégicas e conte comigo para ajudar na análise do seu edital.',
  rating: null,
  created_at: '',
  updated_at: '',
};

interface AiManagementBiddingAskEditalProps {
  biddingId: number;
}
const AiManagementBiddingAskEdital: React.FC<AiManagementBiddingAskEditalProps> = ({
  biddingId,
}) => {
  const [open, setOpen] = useState(false);
  const [showSavedQuestions, setShowSavedQuestions] = useState(false);

  const session = useBiddingChatSession({ biddingId, active: open, clearOnBiddingChange: true });

  const sendMessage = (message?: string) => {
    session.sendMessage(message);
    setShowSavedQuestions(false);
  };

  return (
    <Container open={open}>
      <button
        type="button"
        className="ask-edital-bar"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls="ask-edital-panel"
      >
        Pergunte ao edital
        <span className="material-icons" aria-hidden>
          {open ? 'expand_more' : 'expand_less'}
        </span>
      </button>

      {open && (
        <div className="ask-edital-panel" id="ask-edital-panel">
          <div className="ask-edital-header">
            <h5>Pergunte ao edital</h5>
            <button
              type="button"
              className={`btn ask-edital-saved-toggle ${showSavedQuestions ? 'is-active' : ''}`}
              onClick={() => setShowSavedQuestions((prev) => !prev)}
              disabled={session.isLoadingMessage}
              aria-expanded={showSavedQuestions}
            >
              Perguntas Salvas
            </button>
          </div>

          <BiddingChatStyles className="ask-edital-body">
            <div className="ask-edital-chat">
              <BiddingChatConversation session={session} welcomeMessage={WELCOME_MESSAGE} />
            </div>

            {showSavedQuestions && (
              <aside className="ask-edital-saved">
                <div className="ask-edital-saved-header">
                  <h6>Perguntas Salvas</h6>
                  <button
                    type="button"
                    className="ask-edital-saved-close"
                    onClick={() => setShowSavedQuestions(false)}
                    aria-label="Fechar perguntas salvas"
                  >
                    ×
                  </button>
                </div>
                <UserQuestion
                  onCloseDrawer={() => setShowSavedQuestions(false)}
                  sendMessage={sendMessage}
                />
              </aside>
            )}
          </BiddingChatStyles>
        </div>
      )}
    </Container>
  );
};

export default AiManagementBiddingAskEdital;
